// eslint-disable-next-line import/no-unresolved
import KeenSlider from './keen-slider-with-wheel.js'

if (!customElements.get('product-carousel')) {
  customElements.define(
    'product-carousel',
    class ProductCarousel extends window.BAO.CustomElement {
      constructor () {
        super()

        if (this.els.slide.elements.length < 2) return

        this.carousel = this.initialiseCarousel()
      }

      initialiseCarousel () {
        if (this.els.slide.elements.length > 3) {
          this.els.slides.element.setAttribute(
            'data-custom-cursor-external-el',
            'carousel',
          )
        }

        return new KeenSlider(this.els.slides.element, {
          duration: 1000,
          mode: 'snap',
          slidesPerView: 1.3,
          slides: '.car-Carousel_Slide',
          spacing: 15,
          breakpoints: {
            '(min-width: 768px)': {
              centered: true,
              loop: true,
              mode: 'snap',
              controls: this.els.slide.elements.length > 2,
              slidesPerView: 2,
              spacing: 30,
            },
            '(min-width: 900px)': {
              centered: true,
              loop: true,
              mode: 'snap',
              controls: this.els.slide.elements.length > 3,
              slidesPerView: 3,
              spacing: 30,
            },
            '(min-width: 1600px)': {
              centered: true,
              loop: true,
              mode: 'snap',
              controls: this.els.slide.elements.length > 4,
              slidesPerView: 4,
              spacing: 30,
            },
          },
          move: instance => {
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.details().relativeSlide,
              )
            })
          },
          created: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.addEventListener('click', () => {
                instance.moveToSlide(dot.dataset.slide)
              })
            })
          },
          slideChanged: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.setAttribute(
                'aria-current',
                parseInt(dot.dataset.slide) === instance.details().relativeSlide,
              )
            })
          },
        })
      }
    },
  )
}
